// JS
import '../../custom/js/indexOptimized';

// Base SCSS
import '../../custom/scss/style.scss';